import { ServiceTransitionError } from "../reducers/reducer-serviceTransition";
import { refreshReducersToInitial } from "./refreshData-action";

export const UPDATE_SERVICE_TRANSITION = "UPDATE_SERVICE_TRANSITION" as const;

type UpdateServiceTransitionPaylod = {
  errorMessageContent?: ServiceTransitionError;
  declineType?: string;
  serviceType?: string;
};

export const updateServiceTransition = (payload: UpdateServiceTransitionPaylod) => ({
  type: UPDATE_SERVICE_TRANSITION,
  payload,
} as const);

export type ServiceTransitionActions =
  | ReturnType<typeof updateServiceTransition>
  | ReturnType<typeof refreshReducersToInitial>;
